import * as React from 'react';

/**
 * Adapted from https://github.com/abdennour/react-progressbar/blob/master/src/index.js
 * because the maintainer refuses to update to a newer version of React.
 */

interface IProgressProps {
    completed: number;
    color: string;
    animation: number;
    height: number;
    className?: string;
    children?: React.ReactNode;
}

class Progress extends React.Component<IProgressProps, {}> {
    constructor(props: IProgressProps) {
        super(props);
    }

    static defaultProps = {
        completed: 0,
        color: '#0BD318',
        animation: 200,
        height: 10,
    };

    render() {
        const { color, completed, animation, height, className, children, ...rest } = this.props;

        const style = {
            backgroundColor: color,
            width: completed + '%',
            transition: `width ${animation}ms`,
            height: height,
        };

        return (
            <div className={className || 'progressbar-container'} {...rest}>
                <div className="progressbar-progress" style={style}>
                    {children}
                </div>
            </div>
        );
    }
}

export default Progress;